import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [navTheme, setNavTheme] = useState("light");
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: "Home", path: "/homepage-cinematic-gateway", icon: "Home" },
    { name: "About", path: "/studio-universe-about", icon: "Users" },
    { name: "Portfolio", path: "/cinematic-showcase-portfolio", icon: "Film" },
    { name: "Services", path: "/corporate-solutions-services", icon: "Briefcase" },
    // { name: "Client Stories", path: "/brand-collaborations-client-stories", icon: "Star" },
  ];


  useEffect(() => {
    const sections = document.querySelectorAll("section[data-theme]");

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const theme = entry.target.getAttribute("data-theme");
            setNavTheme(theme);
          }
        });
      },
      {
        rootMargin: "-20% 0px -20% 0px",
        threshold: 0.1,
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActivePath = (path) => location.pathname === path;

  const textColor =
    navTheme === "light" ? "text-black" : "text-white";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-lg transition-colors duration-300 ${isScrolled ? "border-b border-white/10" : "border-b border-transparent"
        }`}
    >
      <div className=" mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">

          {/* LOGO */}
          <Link
            to="/homepage-cinematic-gateway"
            className="flex items-center space-x-3"
            onClick={() => setIsMenuOpen(false)}
          >
            <div className="w-[120px] h-[120px] overflow-hidden rounded-lg">
              <img
                src={
                  navTheme === "light"
                    ? "/assets/images/logo/1.png"
                    : "/assets/images/logo/2.png"
                }
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
          </Link>

          {/* DESKTOP NAV */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 text-sm font-medium transition-all duration-300 ${isActivePath(item.path)
                  ? "text-accent"
                  : `${textColor} hover:text-accent`
                  }`}
              >
                {item.name}
                {isActivePath(item.path) && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent rounded-full" />
                )}
              </Link>
            ))}
          </nav>

          {/* DESKTOP CTA */}
          <div className="hidden lg:flex">
            <Link
              to="/booking-concierge-premium-consultation"
              className="bg-red-600 hover:bg-accent-dark text-white px-6 py-3 rounded-lg font-semibold text-sm transition-all"
            >
              Schedule Consultation
            </Link>
          </div>

          {/* MOBILE MENU BUTTON */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors duration-300 ${textColor} hover:text-accent`}
            aria-label="Toggle menu"
          >
            <Icon name={isMenuOpen ? "X" : "Menu"} size={24} strokeWidth={2} />
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div
        className={`lg:hidden fixed inset-x-0 top-20 bg-white shadow-lg transition-all duration-300 ${isMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"
          }`}
      >
        <nav className="px-4 py-6 space-y-2">
          {navigationItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsMenuOpen(false)}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all ${isActivePath(item.path)
                ? "bg-accent/10 text-accent"
                : "text-black hover:bg-gray-100 hover:text-accent"
                }`}
            >
              <Icon name={item.icon} size={20} strokeWidth={2} />
              <span>{item.name}</span>
            </Link>
          ))}

          <div className="pt-4 border-t">
            <Link
              to="/booking-concierge-premium-consultation"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center justify-center bg-accent text-white px-6 py-4 rounded-lg font-semibold"
            >
              Schedule Consultation
            </Link>
          </div>
        </nav>
      </div>

      {/* OVERLAY */}
      {isMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/20 backdrop-blur-sm z-40"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
